import { render, staticRenderFns } from "./InputCheckbox.vue?vue&type=template&id=54a5bede&scoped=true&"
import script from "./InputCheckbox.ts?vue&type=script&lang=ts&"
export * from "./InputCheckbox.ts?vue&type=script&lang=ts&"
import style0 from "./InputCheckbox.scss?vue&type=style&index=0&id=54a5bede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a5bede",
  null
  
)

export default component.exports